import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    backgroundColor: "black",
    margin: 10,
  },
  deleteIcon: {
    elevation: 4,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    position: "absolute",
    top: 0,
    right: 0,
    padding: 3,
    margin: 10,
    zIndex: 10,
    backgroundColor: "#ccc",
    borderRadius: 50,
  },
  icon: {
    color: "white",
    fontSize: 20,
  },
  thumbnail: {
    width: 250,
    height: 250,
  },
  fullscreen: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "black",
  },
  fileErrorContainer: {
    backgroundColor: "#ccc",
    alignItems: "center",
    justifyContent: "center",
  },
  errorHeading: {
    fontSize: 15,
    padding: 5,
    color: "white",
    textAlign: "center",
  },
  errorMessage: {
    fontSize: 13,
    color: "white",
    textAlign: "center",
  },
});
